import { NAME_EDIT_POPOVER_Z_INDEX } from '@/core/constants/layout';

export const nameEditPopoverStyles = {
	root: {
		zIndex: NAME_EDIT_POPOVER_Z_INDEX
	},

	paper: {
		p: 2,
		mt: 1,
		width: 'min(500px, calc(100vw - 32px))',
		backgroundColor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: '8px'
	}
};
